export function getHeightOfElement (element) {
  return parseFloat(getComputedStyle(element, null).height.replace('px', ''))
}

export function getOffsetOfElement (element) {
  const clientRectangle = element.getBoundingClientRect()
  return {
    top: clientRectangle.top + window.pageYOffset,
    left: clientRectangle.left + window.pageXOffset
  }
}
